import React from 'react';
import PropTypes from 'prop-types';
import lowerCase from 'lodash/lowerCase';

class Table extends React.Component {
  getTableBody() {
    return (
      <tbody>
        {this.props.data.map((d, i) => (
          <tr key={i}>
            <td>{d.issue}</td>
            <td className="punctuation">{d.score}/100</td>
            <td className="icon-cell">
              <span className={`icon -${lowerCase(d.direction)}`}></span>
            </td>
          </tr>
        ))}
      </tbody>
    );
  }

  render() {
    return (
      <table className="c-table">
        <thead>
          <tr>
            <td>Issue</td>
            <td className="punctuation">Score 2017 RGI</td>
            <td>Direction</td>
          </tr>
        </thead>
        {this.getTableBody()}
      </table>
    );
  }
}

Table.propTypes = {
  data: PropTypes.array,
  country: PropTypes.string
};

export default Table;



// WEBPACK FOOTER //
// ./app/components/common/charts/Table.jsx